export enum AttachmentType {
    File = 'File',
    Url = 'Url',
}
